import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@app/shared/animations/animations.module';
import { ComponentsModule } from '@app/shared/components/components.module';
import { InspecoesComponent } from './pages/inspecoes/inspecoes.component';
import { DetalhesInspecaoComponent } from './components/detalhes-inspecao/detalhes-inspecao.component';
import { ModalModelosImpressaoComponent } from './components/modal-modelos-impressao/modal-modelos-impressao.component';
import { InspecaoController } from './controllers';

@NgModule({
  declarations: [
    InspecoesComponent,
    DetalhesInspecaoComponent,
    ModalModelosImpressaoComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    ComponentsModule,
    AnimationsModule,
  ],
  providers: [InspecaoController],
  exports: [InspecoesComponent],
})
export class InspecoesModule {}
